import { useState, useEffect } from 'react';

/**
 * Hook to detect if the app is running as an installed PWA (standalone mode).
 */
export function usePWAMode(): boolean {
  const [isStandalone, setIsStandalone] = useState(() => {
    if (typeof window === 'undefined') return false;

    // Check display-mode media query
    const standaloneQuery = window.matchMedia('(display-mode: standalone)');
    if (standaloneQuery.matches) return true;

    // Check iOS Safari standalone mode
    // @ts-expect-error - iOS Safari specific property
    if (window.navigator.standalone === true) return true;

    return false;
  });

  useEffect(() => {
    const standaloneQuery = window.matchMedia('(display-mode: standalone)');

    const handleChange = (e: MediaQueryListEvent) => {
      setIsStandalone(e.matches);
    };

    standaloneQuery.addEventListener('change', handleChange);
    return () => standaloneQuery.removeEventListener('change', handleChange);
  }, []);

  return isStandalone;
}
